import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useAddPartnerNoteModal } from '../context/AddPartnerNoteModalContext';

const AddPartnerNoteModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useAddPartnerNoteModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('AddAnnotation')}&nbsp;</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default AddPartnerNoteModalHeader;
